import React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { useVendorPortalSession } from "../session/vendorPortalSession";
import "../vendorPortal.css";

var VendorPortalLayout = function (props) {
  var session = useVendorPortalSession();
  if (session.status === "loading") {
    return (
      <div className="vp-shell">
        <div className="vp-main" style={{ textAlign: "center", paddingTop: 48 }}>Loading…</div>
      </div>
    );
  }
  if (session.status !== "authenticated") {
    return <Redirect to="/vendor-portal/login" />;
  }
  var op = session.operator;
  return (
    <div className="vp-shell">
      <header className="vp-topbar">
        <div>
          <h1>{op ? op.stall_name || op.vendor_name : "Vendor"}</h1>
          <div style={{ fontSize: 11, opacity: 0.85 }}>
            {session.staff && session.staff.name}
          </div>
        </div>
        <button
          type="button"
          className="vp-btn vp-btn--ghost"
          style={{ width: "auto", padding: "6px 12px", fontSize: 12, color: "#fff", borderColor: "rgba(255,255,255,0.4)" }}
          onClick={function () { session.logout(); }}
        >
          Logout
        </button>
      </header>
      <main className="vp-main">{props.children}</main>
      <nav className="vp-nav">
        <NavLink exact to="/vendor-portal" activeClassName="vp-nav--active">Home</NavLink>
        <NavLink to="/vendor-portal/stock" activeClassName="vp-nav--active">Stock</NavLink>
        <NavLink to="/vendor-portal/orders" activeClassName="vp-nav--active">Orders</NavLink>
      </nav>
    </div>
  );
};

export default VendorPortalLayout;
